import { render, staticRenderFns } from "./BomForwardDetailDeploy.vue?vue&type=template&id=b825dde2&"
import script from "./BomForwardDetailDeploy.vue?vue&type=script&lang=js&"
export * from "./BomForwardDetailDeploy.vue?vue&type=script&lang=js&"
import style0 from "./BomForwardDetailDeploy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports